import React, { Component, PropTypes } from 'react'
import {trimStart, partial } from 'lodash'
import classNames from 'classnames'
import * as Services from 'Services'
import Price from './Price'
import PaintFillChooser from './PaintFillChooser'
import ControlledTextInput from './ControlledTextInput'

class InitialsChooser extends Component { 

  constructor(props) {
    super(props);
    this.handleCharacterInput = this.handleCharacterInput.bind(this);
	this.state = {
	  initialsValid: true
    };
	
	window.initialsTimer = null;
  }

  //remove copy/paste non-alphanumeric characters
  handleCharacterInput(onFieldChange, inputVal) {
	if(window.initialsTimer != null) {
		clearTimeout(window.initialsTimer);
	}
	
    let initVal = inputVal;
    let outputVal = this.props.allowSpaces ? trimStart(initVal).replace(/[^a-zA-Z0-9. ]/g, "") : initVal.replace(/[^a-zA-Z0-9.]/g, "");
    onFieldChange('characters', outputVal);
	
	//if they are done typing, validate initials
	window.initialsTimer = setTimeout(()=>{ this.isValidInitials(this, inputVal);  }, 500);
  }
  
  isValidInitials(vm, initials){
		if(initials.length > 0)
		{
			Services.checkInitialsValid(initials, vm, function(vm, data) {
		  
			  if(!data.Success) {
				const element2 = document.getElementById(vm.props.id);
			
				var evt2 = new Event('input', { bubbles: true });
				evt2.simulated = true;
				element2.value = '';
				element2.dispatchEvent(evt2);
		  
			  }
			  vm.setState({initialsValid: data.Success});

			});
  
		}  
  }
  
  

  render() {
      const { id, initials, paintLoc, selected, paints, selectedPaint, personalizationStyles, onFieldChange, onFieldChangeAdditionalOptions, onTextEntry, onSelectPaintFill, isError, isPaintError} = this.props;
    return (
      <div className="initials-chooser">
        <div className="side-checkbox">
          <label className={selected.enabled ? 'option-selected' : ''}>
            <div className={(selected.enabled ? 'option-selected' : '') + ' checkbox-target'}></div>
                    <input type="checkbox" checked={selected.enabled} onChange={(evt) => { onFieldChange('enabled', !selected.enabled); if (typeof onFieldChangeAdditionalOptions !== 'undefined') onFieldChangeAdditionalOptions('enabled', !selected.enabled) }} />
            {initials.labelAlternate1}
            {initials.price > 0 && 
              <Price value={initials.price} />
            }
          </label>
        </div>
        
        {selected.enabled &&
          <div>
            <div className={classNames("initials-options", {"error": (isError || !this.state.initialsValid )})}>
              <div className="include-paintfill">Includes Paintfill</div>
              <ControlledTextInput value={selected.characters} 
                id={this.props.id}
				onChange={partial(this.handleCharacterInput, onFieldChange)} 
                onBlur={(e) => {
					this.isValidInitials(this, e)
				}}
				maxLength={initials.maxCharacters} 
                onKeyPress={(e) => {
                  const re = this.props.allowSpaces ? /[a-zA-Z0-9. ]+/g : /[a-zA-Z0-9.]+/g;
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                } 
              }/>
			  {!this.state.initialsValid &&
			    <div className="error">Restricted initials requested.</div>
			  }
              {initials.allowPeriods &&
                <div className="side-checkbox">
                  <label className={selected.separateWithPeriods ? 'option-selected' : ''}>
                    <div className={(selected.separateWithPeriods ? 'option-selected' : '') + ' checkbox-target'}></div>
                    <input type="checkbox"
                      checked={selected.separateWithPeriods}
                      onChange={(evt) => onFieldChange('separateWithPeriods', evt.target.checked)}
                    />
                    Separate With Periods
                  </label>
                </div>
              }
              <div className="letter-style-options">
                <div className="letter-style-text">Letter Style</div>
                <div className="letter-style-radio-btns">
                  {personalizationStyles.map(s => (
                    <div key={s.id} className="side-radio">
                      <label className={(selected.personalizationStyleId === s.id) ? 'option-selected' : ''}>
                        <div className={(selected.personalizationStyleId === s.id ? 'option-selected' : '') + " radio-target"} ></div>
                        <input type="radio"
                          name={('styleChooser' + initials.label)}
                          value={s.id}
                          onChange={(evt) => onFieldChange('personalizationStyleId', s.id)}
                          checked={(selected.personalizationStyleId === s.id)}
                        />
                        {s.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <PaintFillChooser key={paintLoc.id}
              loc={paintLoc}
              paints={paints}
              selectedPaint={selectedPaint}
              isError={isPaintError}
              onSelectPaintFill={(paint) => onSelectPaintFill(paintLoc.id, paint.id)}
              isOpen={true}
            />
          </div>
        }
      </div>
    )
  }
}

InitialsChooser.defaultProps = {
  isError: false,
  isPaintError: false
}


InitialsChooser.propTypes = {
  initials: PropTypes.shape({
    labelAlternate1: PropTypes.string.isRequired,
  }),
  paintLoc: PropTypes.object,
  selected: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    characters: PropTypes.string.isRequired,
    separateWithPeriods: PropTypes.bool.isRequired,
    personalizationStyleId: PropTypes.number.isRequired,
  }),
  paints: PropTypes.array.isRequired,
  selectedPaint: PropTypes.object,
  personalizationStyles: PropTypes.arrayOf(PropTypes.object),
  onFieldChangeAdditionalOptions: PropTypes.func,
  onFieldChange: PropTypes.func,
  onSelectPaintFill: PropTypes.func, 
}

export default InitialsChooser